import { atom } from "recoil"
import { Entity, FolderTree, UserPerSite } from "../../api-client-nswag/custompermission-client"


export interface LegalEntitiesState {
  entities: Entity[]
  usersPerSite: UserPerSite[]
  snapshotEntities: Entity[]
  folderPermission: FolderTree
  folderPermissionSnapshot: FolderTree
  isButtonDisabled: boolean | null
}

export const legalEntitiesState = atom<LegalEntitiesState>({
  key: "legalEntities/state",
  default: {
    entities: [],
    usersPerSite: [],
    snapshotEntities: [],
    folderPermission: [],
    folderPermissionSnapshot: [],
    isButtonDisabled: false,
  },
})
